<template>
  <transition name="">
    <section class="viewer history active" id="ViewerVersion">
      <h2 class="hide">활동내역 레이어</h2>
      <button type="button" class="opinion_search_closed" @click="viewerVersionClose()"></button>

      <div class="scroll_box">
        <div class="day" :class="selectedDate == date ? '' : 'active'" v-for="(date, index) in dateList" :key="index">
          <div class="day_tit" @click="selectDate(date)" v-if="today == date">{{ $i18nUtil.trans("message.today","오늘") }}</div>
          <div class="day_tit" @click="selectDate(date)" v-else-if="yesterday == date">{{ $i18nUtil.trans("message.yesterday","어제") }}</div>
          <div class="day_tit" @click="selectDate(date)" v-else>{{ date }}</div>
            <div class="box" v-for="(version, index) in versionList" :key="index">
              <div class="point"><div></div></div>
              <div class="tit" @click="displayVersion(version.fileVersionId)">
                {{ $i18nUtil.trans("message.fileViewer.ver","버전 {ver}", {ver: version.versionName}) }}
                <div class="dividing_line_ty3"
                  v-if="version.fileVersionId == currentVersionInfo.fileVersionId"
                ></div>
                <button type="button"
                  v-if="version.fileVersionId == currentVersionInfo.fileVersionId"
                  @click="confirmRestoreFileVersion(version)"
                >
                  {{ $i18nUtil.trans("button.version.update","버전 업데이트") }}
                </button>
              </div>
              <div class="member">
                <div class="droplayer tooltipmember relative">
                  <v-menu offset-y>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on" class="name"><b>{{ $i18nUtil.getLanguage() !== 'ko' && version.regUserNameEn != null ? version.regUserNameEn : version.regUserName }}</b></v-btn>
                    </template>
                    <div class="dropdown-list">
                      <UserTooltip
                        :userId="version.regUserId"
                      />
                    </div>
                  </v-menu>
                </div>
                <span class="date">{{ $moment(version.regDate).format("YYYY.MM.DD HH:mm") }}</span>
              </div>
            </div>
            <div class="btn_box txtc" v-if="selectedDate == date && pageIndex + 1 < totalPages && moreViewCount > 0">
              <button type="button" class="btn-more-ico_small1 down" @click="moreView()">{{ $i18nUtil.trans("button.data.more","{cnt}건 더보기", {cnt: moreViewCount}) }}</button>
            </div>
        </div><!-- //day -->
      </div> <!-- //scroll_box -->
    </section>
  </transition>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from "vuex";
import UserTooltip from "@/components/cowork/common/user/UserTooltip";
export default {
  components: {
    UserTooltip
  },
  props: {
    itemInfo: Object,
  },
  data() {
    return {
      reqData : {
        fileId: null,
        groupId: null,
        fileVersionId: null,
        sharepointSiteId: null,
        sharepointFolderId: null,
        sharepointFileId: null,
        type: 'SINGLE'
      },
      totalCount: 0,
      totalPages: 0,
      pageIndex: 0,
      pageSize: 10,
      latestVersionInfo: {},
      currentVersionInfo: {},
      today: '',
      yesterday: '',
      selectedDate: '',
      dateList: [],
      versionList: [],
      currentCount: 0,
      moreViewCount: 0
    };
  },
  methods: {
    // 공통 AXIOS 호출하여 통신 (restAction.js)
    ...mapActions("restAction", ["ASYNC_COWORK_REST_ACTION"]),
    /* 닫기 */
    viewerVersionClose() {
      document.getElementById('ViewerVersion').classList.toggle('active');
      this.$emit('viewerVersion');
    },
    /* 초기화면 */
    initVersion(version, initReqData) {
      let obj = this;

      obj.reqData = initReqData;
      obj.totalCount = version.totalCount;
      obj.latestVersionInfo = version.latestVersionInfo;
      obj.currentVersionInfo = version.currentVersionInfo;

      obj.totalCount = 0;
      obj.totalPages = 0;
      obj.pageIndex = 0;
      obj.selectedDate = '';
      obj.currentCount = 0;
      obj.moreViewCount = 0;
      obj.versionList = [];

      obj.getFileVersionRegDateList();
    },
    /* 버전 등록일 목록 조회 */
    getFileVersionRegDateList() {
      let obj = this;
      let reqData = {
        url: "/api/cofile/cofile/getFileVersionRegDateList",
        method: "post",
        req: obj.reqData,
      };
      obj
        .ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          let errorCode = res.errorCode;
          if (errorCode == null) {
            obj.today = res.result.today;
            obj.yesterday = res.result.yesterday;
            obj.selectedDate = res.result.regDateList[0];
            obj.dateList = res.result.regDateList;
            obj.getFileVersionListByRegDate();
          } else if (errorCode != null) {
            console.log('Error Occured. errorcode : ' + errorCode);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 버전 목록 조회 */
    getFileVersionListByRegDate() {
      let obj = this;
      let reqData = {
        url: "/api/cofile/cofile/getFileVersionListByRegDate",
        method: "post",
        req: {
          fileId : obj.reqData.fileId,
          regDate : obj.selectedDate,
          pageIndex : obj.pageIndex,
          pageSize : obj.pageSize
        },
      };
      obj
        .ASYNC_COWORK_REST_ACTION(reqData)
        .then(function (res) {
          let errorCode = res.errorCode;
          if (errorCode == null) {
            let currentVersionList = obj.versionList;
            let currentCount = obj.currentCount;

            obj.totalCount = res.result.versionList.totalElements;
            obj.totalPages = res.result.versionList.totalPages;
            obj.currentCount = currentCount + res.result.versionList.numberOfElements;

            for(let i=0; i<res.result.versionList.content.length; i++) {
              currentVersionList.push(res.result.versionList.content[i]);
            }

            obj.versionList = currentVersionList;

            if(obj.totalCount - obj.currentCount >= obj.pageSize) {
              obj.moreViewCount = obj.pageSize;
            } else { 
              if(obj.totalCount - obj.currentCount > 0) {
                obj.moreViewCount = obj.totalCount - obj.currentCount;
              } else {
                obj.moreViewCount = 0;
              }
            }
          } else if (errorCode != null) {
            console.log('Error Occured. errorcode : ' + errorCode);
          }
        })
        .catch(function (err) {
          console.log(err);
        });
    },
    /* 날짜 선택 */
    selectDate(date) {
      let obj = this;
      let selectedDate = obj.selectedDate;
      
      if(selectedDate == date) {
        obj.totalCount = 0;
        obj.totalPages = 0;
        obj.pageIndex = 0;
        obj.selectedDate = '';
        obj.currentCount = 0;
        obj.moreViewCount = 0;
        obj.versionList = [];
      } else {
        obj.totalCount = 0;
        obj.totalPages = 0;
        obj.pageIndex = 0;
        obj.selectedDate = date;
        obj.currentCount = 0;
        obj.moreViewCount = 0;
        obj.versionList = [];

        obj.getFileVersionListByRegDate();
      }
    },
    /* 파일 버전 전환 */
    displayVersion(fileVersionId) {
      let obj = this;
      if(fileVersionId == obj.currentVersionInfo.fileVersionId) {
        return;
      }

      let version = {
        fileVersionId : fileVersionId
      };
      
      obj.$emit('displayOtherVersion', version);
    },
    /* 버전 업데이트 */
    confirmRestoreFileVersion(version) {
      let obj = this;
      let isLatestVersion = false;

      if(version.fileVersionId === obj.latestVersionInfo.fileVersionId) {
        isLatestVersion = true;
      } else {
        isLatestVersion = false;
      }

      obj.$emit('confirmRestoreFileVersion', isLatestVersion);
    },
    /* 더보기 클릭 */
    moreView() {
      let obj = this;
      let pageIndex = obj.pageIndex;

      obj.pageIndex = pageIndex + 1;
      obj.getFileVersionListByRegDate();
    },
  }
};
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/file/version/ViewerVersionHistoryByRegDate.vue